// import components
import Profile from '@/components/person/Profile.vue'
import Search from '@/components/person/Search.vue'
export default [
  {
    path: 'profile',
    component: Profile
  },
  {
    path: 'search',
    component: Search
  }
]
